export default "__VITE_ASSET__BplkjAH___"